import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../Services/ProfileProvider";
import Header from "../../CoustamComponent/Header";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import ChartWithHighLow from '../../CoustamComponent/ChartWithHighLow';
import moment from "moment";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";

const TraderDetails = () => {

	const { wlletBalance, userDetails, handleWalletBalance } = useContext(ProfileContext);
	const location = useLocation();
	const { state } = location;
	const [masterData, setMasterData] = useState("")
	const [tradeList, setTradeList] = useState([])
	const [masterBalance, setMasterBalance] = useState("")
	const [proprationValue, setProprationValue] = useState("")
	const [showModel, setShowModel] = useState(false);
	const [isActive, setIsActive] = useState("closeOrder");
	const [masterTransaction, setMasterTranaction] = useState([]);
	const [isMasterFollowed, setIsMasterFollowed] = useState();

	const KycStatus = userDetails?.kycVerified;

	const navigate = useNavigate();



	const formatNumber = (number) => {
		return new Intl.NumberFormat('en-US').format(number);
	}

	const handleViewMaster = async () => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.viewMasterDetail(state?.masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				setMasterData(result?.data?.[0]);
				handleMasterTradeDetails(result?.data?.[0]?.masterId);
				handleFetchMasterBalance(result?.data?.[0]?.masterId);
				handleMasterTransaction(result?.data?.[0]?.masterId);
				handleCheckMasterFollowed(result?.data?.[0]?.masterId);
			} else {
				// alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleMasterTradeDetails = async (masterId) => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.tradeDetails(masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				setTradeList(result?.data?.reverse());
			} else {
				// alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleFetchMasterBalance = async (masterId) => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.fetchMasterBalance(masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				setMasterBalance(result?.data);
			} else {
				// alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};


	const handleMasterTransaction = async (masterId) => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.getMasterTransaction(masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				setMasterTranaction(result?.data);
			} else {
				// alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};


	const handleCheckMasterFollowed = async (masterId) => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.check_master_followed(masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				setIsMasterFollowed(result?.data?.isFollowing);
				console.log('checkMasterFollowed', result?.data?.isFollowing);
			}
		} catch (error) {
			alertErrorMessage(error);
		}
	};


	const handleUserFollow = async (proprationValue) => {
		if (!proprationValue) {
			alertErrorMessage("Please Enter Price");
			return
		}
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.followMaster(proprationValue, state?.masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				setShowModel(false);
				handleWalletBalance();
				navigate("/copier_area")
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	useEffect(() => {
		handleViewMaster()
	}, []);


	const data = [
		{ name: 'Day 1', high: 4000, low: 2400 },
		{ name: 'Day 2', high: 3000, low: 1398 },
		{ name: 'Day 3', high: 2000, low: 9800 },
		{ name: 'Day 4', high: 2780, low: 3908 },
		{ name: 'Day 5', high: 1890, low: 4800 },
	];

	const [hoveredId, setHoveredId] = useState(null);

	const handleMouseEnter = (id) => {
		setHoveredId(id);
	};

	const handleMouseLeave = () => {
		setHoveredId(null);
	};




	const [visibleCount, setVisibleCount] = useState(15);

	// Function to load more items
	const loadMore = () => {
		setVisibleCount(prevCount => prevCount + 10);
	};

	// Sort and filter the tradeList
	const sortedTradeList = [...tradeList]
		.sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)))
		.reverse();


	const today = moment().format('YYYY-MM-DD');

	const groupedTrades = sortedTradeList.reduce((acc, trade) => {
		const date = moment(trade.createdAt).format('YYYY-MM-DD');
		if (!acc[date]) {
			acc[date] = [];
		}
		acc[date].push(trade);
		return acc;
	}, {});


	return (
		<div class="wrapper saprate_page ">
			<div class=" page-body ">
				<div class="page-wrap">
					<Header />
					<div className="page_wrapper" >
						<div className=" ct-header__top" >
							<div class="container">
								<div class="ct-header__inner">
									<h2 class="ct-header__name">
										Copy Trading
									</h2>
									<div class="ct-header__wallet">
										<div class="ct-wallet">
											<div class="ct-wallet__balance">
												<div class="ct-wallet__head"> Wallet balance </div>
												<div class="ct-wallet__count">
													<div class="ct-wallet__count-int"> ${formatNumber(wlletBalance?.balance?.toFixed(2) || 0)} </div>
												</div>
											</div>
											{KycStatus === 2 &&
												<div class="ct-wallet__nav">
													<Link to="/withdraw" class="ct-wallet__withdrawal  btn btn-primary-light btn-sm">
														Withdrawal
													</Link>
													<Link to="/deposit" class="ct-wallet__deposit btn btn-primary btn-sm">
														Deposit
													</Link>
												</div>
											}
										</div>
									</div>
								</div>

								<div className="page_tabs" >
									<div class="nav nav-tabs" id="nav-tab" role="tablist">
										<Link class="nav-link active" id="nav-Rating-tab" to="/copy_trading" >Rating</Link>
										<Link class="nav-link" id="nav-Copier-tab" to={KycStatus === 2 ? "/copier_area" : "/update_kyc"} >Copier Area </Link>
										<Link class="nav-link" id="nav-tandc-tab" to="/terms_conditions" >Terms & Conditions</Link>
									</div>
								</div>
							</div>
						</div>

						<div className="page_wrapper " >
							<div className="container" >
								<div class="row g-3">
									<div class="col-lg-12">
										<div class="card bal_card_main">
											<div className="card-body" >
												<div className="row g-md-5" >
													<div className="col-lg-4" >
														<div className="tr_data">
															<div className="tr_profile tr_profile_xl cursor-pointer" >
																<img className="tr_img" src={ApiConfig?.url + masterData?.master_image || "/assets/images/NEWUSER.jpeg"} alt="" onError={(e) => {
																	e.target.onerror = null;
																	e.target.src = "/assets/images/NEWUSER.jpeg";
																}} />
																<div className="tr_text position-relative archiver_text"
																	onMouseEnter={() => handleMouseEnter(masterData?.masterId)}
																	onMouseLeave={handleMouseLeave}
																>
																	<span>{masterData?.masters_name}</span>
																	<small><i className="ri-bard-fill text-success"></i> {masterData?.master_trader_experitse || "---"}</small>

																	{hoveredId === masterData?.masterId && (
																		<div className="hover_card">
																			<h6>Master Trader's expertise</h6>
																			<div className="">The expertise depends on how long the master trader trades with us,
																				how many trades they have made, and what volume they've made.
																			</div>
																			<ul>
																				<li className={masterData?.master_trader_experitse === "Legend" ? "text-green" : "text-muted"}>
																					<i className={`ri-star-smile-line ${masterData?.master_trader_experitse === "Legend" ? "text-green" : "text-muted"}`}></i>
																					Legend
																				</li>
																				<li className={masterData?.master_trader_experitse === "Expert" ? "text-green" : "text-muted"}>
																					<i className={`ri-bard-fill ${masterData?.master_trader_experitse === "Expert" ? "text-green" : "text-muted"}`} ></i>
																					Expert
																				</li>
																				<li className={masterData?.master_trader_experitse === "High Achiever" ? "text-green" : "text-muted"}>
																					<i className={`ri-bard-line ${masterData?.master_trader_experitse === "High Achiever" ? "text-green" : "text-muted"}`}></i>
																					High Achiever
																				</li>
																				<li className={masterData?.master_trader_experitse === "Growing Talent" ? "text-green" : "text-muted"}>
																					<i className={`ri-star-half-fill ${masterData?.master_trader_experitse === "Growing Talent" ? "text-green" : "text-muted"}`} ></i>
																					Growing Talent
																				</li>
																			</ul>
																		</div>
																	)}
																</div>
															</div>
															{
																isMasterFollowed ?
																	<Link to="/copier_area" className="btn btn-lg btn-warning btn-w-small">MANAGE COPYING</Link>
																	:
																	<button className="btn btn-lg btn-primary btn-w-small" onClick={() => setShowModel(true)} >
																		SETUP COPYING
																	</button>
															}

															<p>Minimum investment ${masterData?.minimum_investment || "---"}</p>
														</div>
													</div>
													<div className="col-lg-8" >
														<div className="row_recw" >
															<div className="col_recw" >
																<p className="text-muted mb-2"> Risk score <i class="ri-question-fill cursor-pointer"></i> </p>
																<span className={`badge ${masterData?.masters_risk_score >= 1 && masterData?.masters_risk_score <= 2
																	? 'bg-green'
																	: masterData?.masters_risk_score >= 3 && masterData?.masters_risk_score <= 4
																		? 'bg-warning'
																		: 'bg-danger'
																	}`} >  {masterData?.masters_risk_score} Risk  </span>
															</div>
															<div className="col_recw" >
																<p className="text-muted mb-2"> Equity⁠  </p>
																<span className="fw-bold" >  {masterData?.equity && "$"}{masterData?.equity?.toFixed(2) || "---"}  </span>
															</div>
															<div className="col_recw" >
																<p className="text-muted mb-2"> Commission⁠  </p>
																<span className="fw-bold" >  {masterData?.masters_commissions}%  </span>
															</div>
															<div className="col_recw" >
																<p className="text-muted mb-2"> With US  </p>
																<span className="fw-bold" >
																	{masterData?.with_us ? `${masterData.with_us}d` : ""}
																</span>
															</div>

															<div className="peragraph" >
																<h6 className="text-muted"> Strategy Description </h6>
																<p>{masterData?.strategy_description || "---"}</p>
															</div>

														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="col-lg-12">
										<div class="card bal_card_main">
											<div className="card-body" >
												<h6 className="mb-3" >Performance</h6>
												<div className="row row_recw mb-3" >

													<div className=" col-lg-3 text-start col_recw" >
														<p className="text-muted mb-2"> Gain⁠  </p>
														<span className="fw-bold" >  {Number(masterData?.totalGain)?.toFixed(2)}%   </span>
													</div>
													<div className="col-lg-4 col_recw" >
														<p className="text-muted mb-2"> Copiers⁠  </p>
														<span className="fw-bold" > {masterData?.masters_copier} <span className={`${masterData?.masters_new_copier_count > 0 ? "text-success" : "text-danger"}`} >

															{
																masterData?.masters_new_copier_count > 0 && (
																	<span>
																		<i className="ri-arrow-up-line"></i> {masterData?.masters_new_copier_count}
																	</span>
																)
															}
															{
																masterData?.masters_new_copier_count < 0 && (
																	<span>
																		<i className="ri-arrow-down-line"></i> {masterData?.masters_new_copier_count}
																	</span>
																)
															}



														</span>
														</span>

													</div>
													<div className=" col-lg-5 col_recw" >
														<p className="text-muted mb-2"> Profit And Loss  </p>
														<div className="pandl_row" >
															<div className="d-flex align-items-center justify-content-between" >
																<span>${masterData?.totalProfit?.toFixed(2)}</span>
																<span>${masterData?.totalLoss?.toFixed(2)} </span>
															</div>
															<div className="risk_progress" >
																<em className="risk_gain" style={{
																	width: `${(masterData?.totalProfit / (masterData?.totalProfit + masterData?.totalLoss)) * 100 || 0}%`
																}} ></em>
																<em className="risk_loss" style={{
																	width: `${(masterData?.totalLoss / (masterData?.totalProfit + masterData?.totalLoss)) * 100 || 0}%`
																}} ></em>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>

									{/* Account details */}
									<div class="col-lg-12">
										<div class="card bal_card_main   h-100">
											<div className="card-body" >
												<h6 className="mb-0" >Account details</h6>
												<div className="row gutter_4 " >
													<div className=" col-lg-6  m-0 col_recw" >
														<p className="text-muted mb-0"> Balance  </p>
														<span className="fw-bold" > $ {masterData?.equity?.toFixed(2)}   </span>
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* <div class="col-lg-12">
										<div class="card bal_card_main   h-100">
											<div className="card-body">
												<div className="chart_here  " >
													<ChartWithHighLow data={tradeList} />
												</div>

											</div>
										</div>
									</div> */}

									{/*   History   */}
									<div class="col-lg-12">
										<div class="card bal_card_main   h-100">
											<div className="card-body">
												<h6>  History  </h6>
												<div className="page_tabs" >
													<div class="nav nav-tabs" id="nav-tab" role="tablist">
														<button class={`nav-link ${isActive === "closeOrder" && 'active'}`} type="button" onClick={() => setIsActive("closeOrder")}>Closed orders</button>
														<button class="nav-link" type="button">Open orders   </button>
														<button class={`nav-link ${isActive === "balanceOperation" && 'active'}`} type="button" onClick={() => setIsActive("balanceOperation")}>  Balance operations </button>
													</div>
												</div>
												{isActive === "closeOrder" &&
													<div className="table_data" >
														<div className="table-responsive" >
															<table className="table">
																<thead>
																	<tr>
																		<th>TRADERS</th>
																		<th>TIME</th>
																		<th>OPEN PRICE</th>
																		<th>CLOSE PRICE</th>
																		<th className="text-end">PROFIT</th>
																	</tr>
																</thead>
																<tbody>
																	{Object.keys(groupedTrades).slice(0, visibleCount).map((date, index) => (
																		<React.Fragment key={index}>
																			<tr>
																				<td colSpan="4">
																					<strong>
																						{date === today ? 'Today' : moment(date).format('DD-MM-YYYY')}
																					</strong>
																				</td>
																			</tr>
																			{groupedTrades[date].map((item, subIndex) => {
																				if (item.type === "trade") {
																					return (
																						<tr className="alt" key={subIndex}>
																							<td>
																								<div className="his_d">
																									{item?.up_and_down === "DOWN" ? (
																										<i className="ri-arrow-right-down-line bg-danger text-white"></i>
																									) : (
																										<i className="ri-arrow-right-up-line bg-green text-white"></i>
																									)}
																									<span>{item?.quantity?.toFixed(2)}</span>
																									{item?.currency}
																								</div>
																							</td>
																							<td>{(item?.time)}</td>
																							<td>{item?.open_price?.toFixed(2)}</td>
																							<td>{item?.close_price?.toFixed(2)}</td>
																							<td className={`text-end ${item?.amount > 0 ? "text-success" : "text-danger"}`}>
																								{item?.amount < 0 ? `-$${Math.abs(item.amount).toFixed(2)}` : `$${item.amount?.toFixed(2)}`}
																							</td>
																						</tr>
																					);
																				} else if (item.type === "deposit_withdrawal") {
																					return (
																						<tr key={subIndex}>
																							<td colSpan="4">
																								<div className="his_d">
																									{item.transaction_type === "DEPOSIT" ? (
																										<span className="text-success">Deposit</span>
																									) : (
																										<span className="text-danger">Withdrawal</span>
																									)}
																									<span className="text-end">${item?.amount}</span>
																								</div>
																							</td>
																						</tr>
																					);
																				}
																				return null;
																			})}
																		</React.Fragment>
																	))}
																</tbody>
																{Object.keys(groupedTrades).length > visibleCount && (
																	<tfoot>
																		<tr>
																			<td colSpan="4" className="text-center">
																				<button onClick={loadMore} type="button" className="btn btn-success">Load More</button>
																			</td>
																		</tr>
																	</tfoot>
																)}
															</table>
														</div>
													</div>
												}

												{isActive === "balanceOperation" &&
													<div className="table_data" >
														<div className="table-responsive" >
															<table className="table">
																<thead>
																	<tr>
																		<th>AMOUNT</th>
																		<th>TRADES</th>
																	</tr>
																</thead>
																<tbody>
																	{masterTransaction?.length > 0 ? (
																		masterTransaction?.map((item, index) => {
																			const transactionDate = moment(item?.createdAt).format('DD-MM-YYYY');
																			return (
																				<React.Fragment key={index}>
																					<tr>
																						<td colSpan="2">
																							<strong>{transactionDate === today ? 'Today' : transactionDate}</strong>
																						</td>
																					</tr>
																					<tr className="alt">
																						<td>
																							{item?.transaction_type === "DEPOSIT" ?
																								<img src="/assets/images/download.svg" className="me-2" />
																								:
																								<img src="/assets/images/download_withdraw.svg" className="me-2" />
																							}
																							{item?.transaction_type}</td>
																						<td>${item?.amount?.toFixed(2)}</td>
																					</tr>
																				</React.Fragment>
																			);
																		})
																	) : (
																		<tr>
																			<td colSpan="2" className="text-center">
																				<div className="favouriteData">
																					<img
																						src="/assets/images/not_found.svg"
																						className="img-fluid"
																						width="250"
																						height="250"
																						alt=""
																					/>
																				</div>
																			</td>
																		</tr>
																	)}
																</tbody>
															</table>
														</div>
													</div>
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Setup Copying */}

			{showModel &&
				<>
					<div class="modal show d-block">
						<div class="modal-dialog modal-dialog-centered">
							<div class="modal-content">
								<div class="modal-header">
									<div className="tr_profile " >
										<img className="tr_img" src={ApiConfig?.url + masterData?.master_image} alt="" />
										<div className="tr_text" >
											<span>{masterData?.masters_name}</span>
											<small>{masterData?.master_trader_experitse}</small>
										</div>
									</div>
									<button type="button" className="btn-close" onClick={() => setShowModel(false)}></button>
								</div>
								<div class="modal-body">
									<div className="py-2 mb-2 note d-flex align-items-center justify-content-between">
										<b>Fund in Wallet :</b>
										<p className="mb-0" > ${wlletBalance?.balance?.toFixed(2) || 0}</p>
									</div>
									<div class="form-group mb-4 mt-4">
										<label> Enter Value </label>
										<div class="input-relative">
											<input type="number" class="form-control" placeholder="$" value={proprationValue} onChange={(e) => setProprationValue(e.target.value)} /><span></span>
										</div>
									</div>
									<section class="subscription-setup__section">
										<article class="ct-dashed-list">
											<h3 class="ct-dashed-list__label text-subtitle-2">
												Summary
											</h3>
											<ul class="ct-dashed-list__items">
												<li class="ct-dashed-list__item _highlighted">
													<div class="ct-dashed-list__item-label text-caption"> Total </div>
													<div class="ct-dashed-list__item-value text-body-2"> ${proprationValue} </div>
												</li>
											</ul>
										</article>
									</section>
									{
										KycStatus === 2 ?

											<button type="button" class="btn btn-primary btn-block w-100 btn-md" onClick={() => handleUserFollow(proprationValue)}>   START COPYING </button>
											:
											<button type="button" class="btn btn-warning btn-block w-100 btn-md">   Kyc Pending </button>
									}
								</div>
							</div>
						</div>
					</div>
					<div className="modal-backdrop" >

					</div>
				</>
			}




		</div>
	)
}

export default TraderDetails


